import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import bullListAction from './bullList.action.json' with { type: 'json' }
import { bullObject } from '../bullObject'

export const bullExpression = expression(bullObject.shape)

const bullListDefinition = defineAction({
  ...bullListAction,

  input: z.object({
    filter: bullExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      name: 'Nome',
      breed: 'Raca',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(
      bullObject.extend({ currentSemenStock: z.number().nullish() }),
    ),
    count: z.number(),
  }),
})

export default bullListDefinition
